import React from 'react'
import OrderUserListItem from './OrderUserListItem'
import styled from 'styled-components'

export default function OrderUserList({ orders, fetchMoreEvidencesSlip, moreEvidencesSlip }) {
  return (
    <>
      {orders.map((order, i) => {
        return (
          <CardContainer key={i}>
            <OrderUserListItem
              order={order}
              fetchMoreEvidencesSlip={fetchMoreEvidencesSlip}
              moreEvidencesSlip={moreEvidencesSlip}
            />
          </CardContainer>
        )
      })}
    </>
  )
}

const CardContainer = styled.div`
  margin-top: 16px;
  border-bottom: 2px solid #e6e6e6;
`
